export default __webpack_public_path__ + "static/media/facebook.0ae1e823.webp";